module.exports = __webpack_public_path__ + "static/media/B13889_Nurse_2_Nurse_Staffing_logo_01.2dcb0982.jpg";